<template>
    <div class="labor-screening">
        <div class="print-button-container">
            <b-button
                type="button"
                variant="outline-primary"
                size="md"
                @click="printForm"
            >
            <span class="button-text">
                Print Form
            </span>
            </b-button>
        </div>
        <h3>
            Louisiana Indicator Tool for Child & Youth Labor Trafficking
        </h3>
        <p
            class="labor-screening__description"
            v-for="(item, id) in detailFields"
            :key="id"
        >
            <span class="labor-screening__description labor-screening__description--bold">
                {{ item.title }}:
            </span>
            {{ item.value }}
        </p>
        <div class="labor-screening__table">
            <b-row class="labor-screening__row">
                <b-col cols="12">
                    <span class="labor-screening__header labor-screening__description--bold">
                        ENDS
                    </span>
                    <span class="labor-screening__header labor-screening__description--italic">
                        The ends of the crime refer to the specific type of victimization that the child or youth is experiencing.
                    </span>
                    <span class="labor-screening__header labor-screening__description--italic">Did the child or youth engage in labor or services against their will, or were they forced to work to pay off debt?</span>
                </b-col>
                <b-col cols="12">
                    <b-form-group disabled>
                        <span class="labor-screening__description--bold">
                            Forced Labor
                        </span>
                        <div class="labor-screening__checkbox-group">
                            <b-form-checkbox
                                class="labor-screening__checkbox"
                                v-for="[key, value] of Object.entries(endsLaborFields['FORCED_LABOR'])"
                                :key="key"
                                v-model="laborScreening[key]"
                            >
                                {{ value.desc }}
                            </b-form-checkbox>
                            <b-form-checkbox
                                class="labor-screening__checkbox"
                                v-model="laborScreeningOther.e_fl_otherText"
                            >
                                Other:
                                <b-form-input
                                    class="labor-screening__form-input"
                                    v-model="laborScreening.e_fl_otherText"
                                />
                            </b-form-checkbox>
                        </div>
                    </b-form-group>
                    <b-form-group disabled>
                        <span class="labor-screening__description--bold">
                            Debt Bondage
                        </span>
                        <div class="labor-screening__checkbox-group">
                            <b-form-checkbox
                                class="labor-screening__checkbox"
                                v-for="[key, value] of Object.entries(endsLaborFields['DEBT_BONDAGE'])"
                                :key="key"
                                v-model="laborScreening[key]"
                            >
                                {{ value.desc }}
                            </b-form-checkbox>
                            <b-form-checkbox
                                class="labor-screening__checkbox"
                                v-model="laborScreeningOther.e_db_otherText"
                            >
                                Other:
                                <b-form-input
                                    class="labor-screening__form-input"
                                    v-model="laborScreening.e_db_otherText"
                                />
                            </b-form-checkbox>
                        </div>
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <span class="labor-screening__header labor-screening__description--bold">
                        MEANS
                    </span>
                    <span class="labor-screening__header labor-screening__description--italic">
                        The means refers to the methods of force, fraud, and coercion a perpetrator uses to keep the child or youth in a trafficking situation.
                    </span>
                    <span class="labor-screening__header labor-screening__description--italic">What did the perpetrator do (or threaten to do) to ensure that the child or youth provided labor or services?</span>
                </b-col>
                <b-col cols="12">
                    <b-form-group disabled>
                        <span class="labor-screening__description--bold">
                            Coercion (psychological, mental, or emotional control)
                        </span>
                        <div class="labor-screening__checkbox-group">
                            <b-form-checkbox
                                class="labor-screening__checkbox"
                                v-for="[key, value] of Object.entries(meansLaborFields['COERCION'])"
                                :key="key"
                                v-model="laborScreening[key]"
                            >
                                {{ value.desc }}
                            </b-form-checkbox>
                            <b-form-checkbox
                                class="labor-screening__checkbox"
                                v-model="laborScreeningOther.m_c_otherText"
                            >
                                Other:
                                <b-form-input
                                    class="labor-screening__form-input"
                                    v-model="laborScreening.m_c_otherText"
                                />
                            </b-form-checkbox>
                        </div>
                    </b-form-group>
                    <b-form-group disabled>
                        <span class="labor-screening__description--bold">
                           Fraud (tricked, lied to, or defrauded)
                        </span>
                        <div class="labor-screening__checkbox-group">
                            <b-form-checkbox
                                class="labor-screening__checkbox"
                                 v-for="[key, value] of Object.entries(meansLaborFields['FRAUD'])"
                                :key="key"
                                v-model="laborScreening[key]"
                            >
                                {{ value.desc }}
                            </b-form-checkbox>
                            <b-form-checkbox
                                class="labor-screening__checkbox"
                                v-model="laborScreeningOther.m_fr_otherText"
                            >
                                Other:
                                <b-form-input
                                    class="labor-screening__form-input"
                                    v-model="laborScreening.m_fr_otherText"
                                />
                            </b-form-checkbox>
                        </div>
                    </b-form-group>
                    <b-form-group disabled>
                        <span class="labor-screening__description--bold">
                           Force (physical control or restraint)
                        </span>
                        <div class="labor-screening__checkbox-group">
                            <b-form-checkbox
                                class="labor-screening__checkbox"
                                v-for="[key, value] of Object.entries(meansLaborFields['FORCE'])"
                                :key="key"
                                v-model="laborScreening[key]"
                            >
                                {{ value.desc }}
                            </b-form-checkbox>
                            <b-form-checkbox
                                class="labor-screening__checkbox"
                                v-model="laborScreeningOther.m_fo_otherText"
                            >
                                Other:
                                <b-form-input
                                    class="labor-screening__form-input"
                                    v-model="laborScreening.m_fo_otherText"
                                />
                            </b-form-checkbox>
                        </div>
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <span class="labor-screening__header labor-screening__description--bold">
                        PROCESS
                    </span>
                    <span class="labor-screening__header labor-screening__description--italic">
                        The 'process' refers to the actions the perpetrator takes to compel the child or youth into a trafficking situation.
                    </span>
                     <span class="labor-screening__header labor-screening__description--italic">What were the intentional acts the perpetrator took to get the child or youth in the situation?</span>
                </b-col>
                <b-col cols="12">
                    <b-form-group disabled>
                        <div class="labor-screening__checkbox-group">
                            <b-form-checkbox
                                class="labor-screening__checkbox"
                                 v-for="[key, value] of Object.entries(processLaborFields)"
                                :key="key"
                                v-model="laborScreening[key]"
                            >
                                {{ value.desc }}
                            </b-form-checkbox>
                            <b-form-checkbox
                                class="labor-screening__checkbox"
                                v-model="laborScreeningOther.p_otherText"
                            >
                                Other:
                                <b-form-input
                                    class="labor-screening__form-input"
                                    v-model="laborScreening.p_otherText"
                                />
                            </b-form-checkbox>
                        </div>
                    </b-form-group>
                </b-col>
            </b-row>
        </div>
        <div class="labor-screening__container">
            <span class="labor-screening__description--bold">
                Conclusion:
            </span>
            <p :class="laborScreeningConclusionClasses">
                {{ LABOR_CONCLUSION_LABEL_MAP[this.laborScreening.conclusion] }}
            </p>
            <div
                class="mb-0"
                v-if="laborScreening.conclusion === LABOR_SCREENING_CONCLUSION.NOT_ENOUGH_INFO"
            >
                <p>If there is one checkbox in one of the categories or no boxes checked, there is not enough information to determine the child or youth is a potential victim of labor trafficking.</p>
                <p><i>Action to be taken: Continue to monitor the child or youth. Follow mandatory reporting guidelines if you suspect abuse or neglect to a child under 18 years of age by a parent or caretaker. If you suspect a crime has occurred or the child or youth is in immediate danger, report to law enforcement.</i></p>
            </div>
            <div
                class="mb-0"
                v-else-if="laborScreening.conclusion === LABOR_SCREENING_CONCLUSION.LEVEL1"
            >
                <p>If there is at least one checkbox in at least two of the categories, there is concern that the child or youth could potentially be a victim of labor trafficking.</p>
                <p><i>Action to be taken: Immediately report to law enforcement if you suspect a crime has occurred or the child or youth is in immediate danger. If you suspect child abuse or neglect to a child under 18 years of age by a parent or caretaker, call the <a href="https://www.dcfs.la.gov/" target="_blank">DCFS</a> Child Abuse/Neglect Hotline at 855-452-5437. Refer to services for additional assessment by contacting the National Human Trafficking Hotline at 888-373-7888 or by referring to <a href="https://humantrafficking.la.gov/resources/" target="_blank">a local service provider</a> with expertise in human trafficking.</i></p>
            </div>
            <div
                class="mb-0"
                v-else-if="laborScreening.conclusion === LABOR_SCREENING_CONCLUSION.LEVEL2"
            >
                <p>If there is at least one checkbox in all three categories (Ends, Means, Process), the child or youth meets the state definition of human trafficking and is considered "indicated" for labor trafficking.</p>
                <p><i>Action to be taken: Immediately report to law enforcement. If you suspect child abuse or neglect to a child under 18 years of age by a parent or caretaker, call the <a href="https://www.dcfs.la.gov/" target="_blank">DCFS</a> Child Abuse/Neglect Hotline at 855-452-5437. Refer the child to Care Coordination by emailing <a href="mailto:carecoordination@lacacs.org">carecoordination@lacacs.org</a> and attach a copy of the screening tool.</i></p>
                <p><i>If the child is a non-U.S. citizen or non-lawful permanent resident, report to <a href="https://www.acf.hhs.gov/otip" target="_blank">HHS Office of Trafficking in Persons (OTIP)</a> by submitting a Request for Assistance (RFA) through <a href="https://atims.acf.hhs.gov/eaasidentityserver/Identity/Account/Login/LoginSelection/" target="_blank">Shepherd</a>. (Contact the OTIP Child Protection Specialists by phone at 202-205-4582 or email at <a href="mailto:ChildTrafficking@acf.hhs.gov">ChildTrafficking@acf.hhs.gov</a>.) Also consider referring the child/youth to an attorney to help assess qualifications for legal relief as a potential trafficking victim.</i></p>
                <p><i>If the individual is a youth, or aged 18 years or older, provide the individual with the National Human Trafficking Hotline at 888-373-7888 and offer to make a referral to <a href="https://humantrafficking.la.gov/resources/" target="_blank">a local service provider</a> with expertise in human trafficking. If the individual is an adult with a disability, report also to Adult Protective Services at 800-898-4910.</i></p>
                <p><i>Update the Victim Status for the child or youth and complete the requested information.</i></p>
                <p><i>Please note: This tool does not include a result for a confirmed victim of human trafficking. If you receive certification of the child or youth being a confirmed victim of trafficking after completing the screening, you must update their victim status to “confirmed.” A trafficking event is considered “confirmed” when evidence supports the conclusion that the individual is a victim of human trafficking, as defined in La. RS 14:46.2, La. RS 14:46.3, or the federal Trafficking Victims Protection Act (TVPA). While the tool does provide indicators to meet the state legal definition of trafficking, the tool is insufficient alone to weigh the totality of evidence or to replace the assessment of qualified professionals (such as, law enforcement, U.S. Attorney, District Attorney, HHS, victim advocate, Care Coordinator, or other qualified professional.)</i></p>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import { LABOR_SCREENING_CONCLUSION, LABOR_CONCLUSION_LABEL_MAP } from '@/helpers/enums'

export default {
    name: 'PrintLaborScreening',

    data () {
        return {
            laborScreeningOther: {},
            friendlyLaborScreeningId: this.$route.params.id,
            LABOR_SCREENING_CONCLUSION,
            LABOR_CONCLUSION_LABEL_MAP
        }
    },

    computed: {
        ...mapGetters({
            laborScreening: 'getLaborScreening',
            laborScreeningFields: 'getLaborScreeningFields'
        }),

        endsLaborFields () {
            return this.laborScreeningFields['ENDS']
        },

        meansLaborFields () {
            return this.laborScreeningFields['MEANS']
        },

        processLaborFields () {
            return this.laborScreeningFields['PROCESS']
        },

        laborScreeningConclusionClasses () {
            return [
                'mb-0',
                'labor-screening__description',
                'labor-screening__description--bold',
                {
                    'text-warning': this.laborScreening.conclusion === LABOR_SCREENING_CONCLUSION.LEVEL1,
                    'text-danger': this.laborScreening.conclusion === LABOR_SCREENING_CONCLUSION.LEVEL2
                }
            ]
        },

        personAge () {
            if (
                !this.laborScreening ||
                !this.laborScreening.person ||
                !this.laborScreening.person.b_birthdate
            ) {
                return ''
            }

            const birthDate = this.laborScreening.person.b_birthdate
            const birthDateUnix = moment(birthDate).unix()

            if (Number.isNaN(birthDateUnix)) {
                return this.laborScreening.person.b_approximate_age || ''
            }
            return moment(Date.now()).diff(birthDate, 'year')
        },

        detailFields () {
            if (!this.laborScreening) {
                return []
            }

            const {
                id,
                organizationCreator,
                location,
                program,
                createdBy,
                person
            } = this.laborScreening

            const programName = program ? (
                program.title === 'Other' ? program.title_otherText : program.title
            ) : ''

            return [
                {
                    title: 'Agency',
                    value: organizationCreator ? organizationCreator.title : ''
                },
                {
                    title: 'Location',
                    value: location ? location.title : ''
                },
                {
                    title: 'Program',
                    value: programName
                },
                {
                    title: 'Email',
                    value: createdBy ? createdBy.emailAddress : ''
                },
                {
                    title: 'Person Record',
                    value: person ? person.id : ''
                },
                {
                    title: 'Labor Screening',
                    value: id
                },
                {
                    title: 'Youth\'s Age',
                    value: this.personAge
                },
                {
                    title: 'Youth\'s Gender Identity',
                    value: person.b_gender === 'Other'
                        ? person.b_gender_otherText
                        : person.b_gender
                },
                {
                    title: 'Youth\'s Race',
                    value: person.b_race === 'Other'
                        ? person.b_race_otherText
                        : person.b_race
                },
                {
                    title: 'Youth\'s Ethnicity',
                    value: person.b_ethnicity || ''
                }
            ]
        }
    },

    watch: {
        laborScreening () {
            this.checkLaborScreeningOtherFields()
        }
    },

    created () {
        this.$store.dispatch('getLaborScreening', {
            id: this.friendlyLaborScreeningId
        })
    },

    methods: {
        checkLaborScreeningOtherFields () {
            const checkedOthersFields = Object.keys(this.laborScreening).filter((key) => key.endsWith('otherText') && !!this.laborScreening[key])
            checkedOthersFields.forEach((field) => {
                this.laborScreeningOther[field] = true
            })
        },

        areFieldsChecked (prefix) {
            return Object.keys(this.laborScreening)
                .filter((key) => key.startsWith(prefix))
                .reduce((isChecked, key) => isChecked || this.laborScreening[key], false)
        },

        printForm () {
            window.print()
        }
    }
}
</script>

<style lang="scss" scoped>
.labor-screening {
    &__header {
        display: block;
    }

    &__description {
        &--bold {
            font-weight: 500;
        }

        &--italic {
            font-style: italic;
        }
    }

    &__checkbox {
        display: block;
    }

    &__checkbox-group {
        padding: 0 15px;
    }

    &__table {
        margin: 15px;
    }

    &__row {
        border: 1px solid #000000;
        border-bottom: none;

        .col-12 {
            padding: 5px;
            border-bottom: 1px solid #000000;
        }
    }

    &__container {
        margin-bottom: 40px;
        padding: 10px;
        border: 1px solid #000000;
    }
}

@media print {
    .labor-screening__checkbox {
        -webkit-print-color-adjust: exact !important;   /* Chrome, Safari 6 – 15.3, Edge */
        print-color-adjust: exact !important;           /* Firefox 97+, Safari 15.4+ */
    }

    .print-button-container {
		display: none;
    }
}
</style>

<style>
@media print {
    .breadcrumb, .app-footer {
        display: none;
    }
}
</style>


// WEBPACK FOOTER //
// src/views/t1/Admin/PrintLaborScreening.vue